/* eslint no-underscore-dangle: 0 */
import axios from 'axios'

axios.defaults.baseURL = API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common.Accept = 'application/json'

const ApiService = {
  setAuthorizationHeader(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  removeAuthorizationHeader() {
    axios.defaults.headers.common['Authorization'] = {}
  },

  get(resource) {
    return axios.get(resource)
  },
  post(resource, data) {
    return axios.post(resource, data)
  },

  put(resource, data) {
    return axios.put(resource, data)
  },

  delete(resource) {
    return axios.delete(resource)
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   * */
  customRequest(data) {
    return axios(data)
  },
}

export default ApiService
